import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { TrustSection } from '../components/TrustSection';
import { StickyFooter } from '../components/StickyFooter';
import { ServicesSection } from '../components/ServicesSection';
import { FadeIn } from '../components/FadeIn';
import { SEO } from '../components/SEO';
export function Home() {
  return <div className="min-h-screen w-full bg-white" data-id="element-1551" data-mp="1ziqvdplqi0ms">
      <SEO title="Care Nomad | Trusted In-Home Care, Nannies & Equipment Rentals" description="Canada's first nurse-led marketplace for real-time staffing, personalized home care solutions, vetted nannies, and premium equipment rentals." data-id="element-1552" data-mp="1zk1uhc48ik7k" />
      {/* Navigation */}
      <Navbar data-id="element-1553" data-mp="2dj1nevys5l9j" />

      {/* Main content */}
      <main id="main-content" data-id="element-1554" data-mp="3kvtkrco2tnww">
        {/* Hero: compact mobile-first with multi-step widget */}
        <HeroSection data-id="element-1555" data-mp="3owcg3gp6hc3u" />

        {/* Trust: Because quality care matters most */}
        <FadeIn data-id="element-1556" data-mp="30wroqfcbfvf0">
          <TrustSection data-id="element-1557" data-mp="30xb9s4x9izx9" />
        </FadeIn>

        {/* How it works: quick 3-step explainer */}
        <FadeIn data-id="element-1558" data-mp="2vxydktki4gi0">
          <HowItWorks data-id="element-1559" data-mp="2vxf13sdmekbd" />
        </FadeIn>

        {/* Explore Care Options Grid */}
        <FadeIn data-id="element-1560" data-mp="2qy2hrhlyjvdj">
          <ServicesSection data-id="element-1561" data-mp="2qxkcxwl8c8u0" />
        </FadeIn>

        {/* The Care Nomad Difference */}
        <FadeIn data-id="element-1562" data-mp="2mxs19b0jhmkf">
          <DifferenceSection data-id="element-1563" data-mp="2mvyw605kraej" />
        </FadeIn>

        {/* FAQ section */}
        <FadeIn data-id="element-1564" data-mp="2hyfhx08vmxml">
          <FAQSection data-id="element-1565" data-mp="2hyywq838d5we" />
        </FadeIn>
      </main>

      {/* Footer */}
      <StickyFooter data-id="element-1566" data-mp="2d6p0kabiv9lo" />
    </div>;
}
function HowItWorks() {
  return <section className="w-full bg-white py-16 lg:py-24 border-b border-gray-100" aria-label="How Care Nomad works" data-id="element-1567" data-mp="2d5dxkcpwi5vm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1568" data-mp="239j74vffr6ia">
        <div className="text-center mb-16" data-id="element-1569" data-mp="2376hdw3frruo">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#1a2332] tracking-tight mb-4" data-id="element-1570" data-mp="1z7pffcn7xcu9">
            CareNomad Check-Ins™ — <span className="text-[#007a87]" data-id="element-1571" data-mp="1u94lfuyk7pe9">AI-Powered Accountability</span>
          </h2>
          <p className="text-[#5a6a7a] text-lg sm:text-xl max-w-2xl mx-auto font-medium" data-id="element-1572" data-mp="1kj5u7u9vf3iq">
            Proprietary technology ensuring safety, transparency, and peace of mind.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 relative" data-id="element-1573" data-mp="1aoduokwqa6lb">
          {/* Connector line (desktop) */}
          <div className="hidden md:block absolute top-1/2 left-8 right-8 h-0 border-t-2 border-dashed border-gray-200 -translate-y-1/2 z-0" aria-hidden="true" data-id="element-1574" data-mp="1fngy60x284r6" />

          {/* Step 1 */}
          <div className="relative z-10 bg-white rounded-3xl p-8 shadow-xl shadow-gray-200/40 border border-gray-100 hover:-translate-y-2 transition-all duration-300 group overflow-hidden" data-id="element-1575" data-mp="1tlx77yiea7ch">
            <div className="absolute -top-6 -right-6 text-9xl font-black text-gray-50 group-hover:text-[#007a87]/5 transition-colors duration-500 pointer-events-none select-none" data-id="element-1576" data-mp="2mackafhyufl6">
              1
            </div>
            <div className="w-14 h-14 bg-[#007a87] text-white rounded-2xl flex items-center justify-center text-2xl font-bold mb-6 shadow-lg shadow-[#007a87]/30 relative z-10 group-hover:scale-110 transition-transform duration-300" data-id="element-1577" data-mp="flamnu6hpu7h">
              1
            </div>
            <h3 className="font-bold text-[#1a2332] text-xl mb-3 relative z-10" data-id="element-1578" data-mp="ofyn9714enpy">
              Automated Geofence & Device Pings
            </h3>
            <p className="text-[#5a6a7a] leading-relaxed relative z-10" data-id="element-1579" data-mp="3stdmh67fl7hu">
              Ensures caregivers are on-site when they say they are, providing real-time location verification without manual check-ins.
            </p>
          </div>

          {/* Step 2 */}
          <div className="relative z-10 bg-white rounded-3xl p-8 shadow-xl shadow-gray-200/40 border border-gray-100 hover:-translate-y-2 transition-all duration-300 group overflow-hidden" data-id="element-1580" data-mp="ot8kv6x21h8">
            <div className="absolute -top-6 -right-6 text-9xl font-black text-gray-50 group-hover:text-[#007a87]/5 transition-colors duration-500 pointer-events-none select-none" data-id="element-1581" data-mp="1c3qd7dfl2z9p">
              2
            </div>
            <div className="w-14 h-14 bg-[#007a87] text-white rounded-2xl flex items-center justify-center text-2xl font-bold mb-6 shadow-lg shadow-[#007a87]/30 relative z-10 group-hover:scale-110 transition-transform duration-300" data-id="element-1582" data-mp="2ccq2kt5zxq3u">
              2
            </div>
            <h3 className="font-bold text-[#1a2332] text-xl mb-3 relative z-10" data-id="element-1583" data-mp="2m92sdfyf7jtb">
              AI Timeline Verification
            </h3>
            <p className="text-[#5a6a7a] leading-relaxed relative z-10" data-id="element-1584" data-mp="2vbbzrwye6x2h">
              Prompts for micro-video and photo updates of meals, activities, and routines to keep you connected to your loved one's day.
            </p>
          </div>

          {/* Step 3 */}
          <div className="relative z-10 bg-white rounded-3xl p-8 shadow-xl shadow-gray-200/40 border border-gray-100 hover:-translate-y-2 transition-all duration-300 group overflow-hidden" data-id="element-1585" data-mp="353hsxa0drkj9">
            <div className="absolute -top-6 -right-6 text-9xl font-black text-gray-50 group-hover:text-[#007a87]/5 transition-colors duration-500 pointer-events-none select-none" data-id="element-1586" data-mp="3e08xkat007pg">
              3
            </div>
            <div className="w-14 h-14 bg-[#007a87] text-white rounded-2xl flex items-center justify-center text-2xl font-bold mb-6 shadow-lg shadow-[#007a87]/30 relative z-10 group-hover:scale-110 transition-transform duration-300" data-id="element-1587" data-mp="tea7jjlr9wsr">
              3
            </div>
            <h3 className="font-bold text-[#1a2332] text-xl mb-3 relative z-10" data-id="element-1588" data-mp="1m2fpxzpc79pf">
              1-Click Video Interviews
            </h3>
            <p className="text-[#5a6a7a] leading-relaxed relative z-10" data-id="element-1589" data-mp="1cd606qhyu34h">
              Indeed-style interview scheduling and secure video rooms built directly into the platform for seamless hiring.
            </p>
          </div>
        </div>
      </div>
    </section>;
}
function DifferenceSection() {
  return <section className="w-full bg-gray-50 py-8 lg:py-12 border-t border-gray-100" data-id="element-1590" data-mp="2028g9twybnwv">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1591" data-mp="3uakks6jf0i9s">
        <div className="text-center mb-10" data-id="element-1592" data-mp="3ubdxdo5221zu">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#1a2332] tracking-tight mb-3" data-id="element-1593" data-mp="26jspnbo8ksh">
            The Care Nomad Difference
          </h2>
          <p className="text-[#3a4a5a] text-base sm:text-lg max-w-2xl mx-auto font-medium" data-id="element-1594" data-mp="3kkj0lpu6nk05">
            Why families and facilities choose us for their care needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1595" data-mp="3al1xng6bfk7v">
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 text-center" data-id="element-1596" data-mp="3fly86cl6a4m9">
            <div className="w-16 h-16 bg-[#007a87]/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-1597" data-mp="31moubjkfvmlg">
              <span className="text-2xl" data-id="element-1598" data-mp="36lt0e1c2h47k">🛡️</span>
            </div>
            <h3 className="font-bold text-xl text-[#1a2332] mb-3" data-id="element-1599" data-mp="zu0msy0riczv">Rigorous Vetting</h3>
            <p className="text-[#3a4a5a] leading-relaxed" data-id="element-1600" data-mp="14tn2de42c5bu">
              Every caregiver passes comprehensive background checks, credential verification, and clinical interviews.
            </p>
          </div>
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 text-center" data-id="element-1601" data-mp="19z0k76zzcgh6">
            <div className="w-16 h-16 bg-[#007a87]/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-1602" data-mp="1nqf3lexsujor">
              <span className="text-2xl" data-id="element-1603" data-mp="1iywzii0hc2zk">⚡</span>
            </div>
            <h3 className="font-bold text-xl text-[#1a2332] mb-3" data-id="element-1604" data-mp="1xo2xk2nkzn5v">Fast & Easy Booking</h3>
            <p className="text-[#3a4a5a] leading-relaxed" data-id="element-1605" data-mp="1xpw9nxgyqzl9">
              Find and book qualified professionals in minutes, not days. Manage schedules and payments all in one place.
            </p>
          </div>
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 text-center" data-id="element-1606" data-mp="22n62ln3k9tdu">
            <div className="w-16 h-16 bg-[#007a87]/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-1607" data-mp="caqd4dlc72j7">
              <span className="text-2xl" data-id="element-1608" data-mp="89mzlxqrhil5">🤝</span>
            </div>
            <h3 className="font-bold text-xl text-[#1a2332] mb-3" data-id="element-1609" data-mp="8bhm3gholirc">Reliable Support</h3>
            <p className="text-[#3a4a5a] leading-relaxed" data-id="element-1610" data-mp="wrz24dq4bx8n">
              Our nurse-led team is here to support you 24/7, ensuring the highest quality of care and service.
            </p>
          </div>
        </div>
      </div>
    </section>;
}
type FAQItem = {
  question: string;
  answer: string;
};
const FAQ_ITEMS: FAQItem[] = [{
  question: 'What services does Care Nomad provide?',
  answer: 'We provide a comprehensive ecosystem: Healthcare Staffing (RN, RPN, PSW), Home Care Solutions (In-home nursing, dementia care), and Virtual Assistant services for facility operations.'
}, {
  question: 'How quickly can I get a worker or assistant placed?',
  answer: 'Our average match time is 4 minutes. Whether you need an emergency shift covered or a virtual assistant to start immediately, our platform is built for speed.'
}, {
  question: 'How are the virtual assistants vetted?',
  answer: 'Just like our clinical staff, virtual assistants undergo rigorous vetting. They are trained in healthcare operations, compliance, and privacy standards (HIPAA/PHIPA).'
}, {
  question: 'Can I use Care Nomad for private home care?',
  answer: 'Yes! Our "Care Solutions" tab is specifically designed for families seeking professional, nurse-supervised care in the comfort of their own homes.'
}, {
  question: 'Is Care Nomad available across Canada?',
  answer: "We currently serve Ontario, British Columbia, and Alberta for all service lines. We're expanding to additional provinces in 2025."
}];
function FAQSection() {
  return <section className="w-full bg-white py-8 lg:py-12" aria-label="Frequently asked questions" data-id="element-1611" data-mp="1krhkrld5enl1">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1612" data-mp="3f3fs1hrwd9ea">
        <div className="text-center mb-10" data-id="element-1613" data-mp="3f2wbo5hwat2d">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#1a2332] tracking-tight mb-3" data-id="element-1614" data-mp="3b24035ljwc2x">
            Frequently Asked Questions
          </h2>
          <p className="text-[#3a4a5a] text-base sm:text-lg font-medium" data-id="element-1615" data-mp="cms0527min7a">
            Everything you need to know about Care Nomad
          </p>
        </div>

        <div className="space-y-4" data-id="element-1616" data-mp="mn0zgowwwoqw">
          <FAQAccordion items={FAQ_ITEMS} data-id="element-1617" data-mp="mlzoekfwc296" />
        </div>

        <div className="mt-10 text-center bg-soft-teal rounded-2xl p-8" data-id="element-1618" data-mp="hn66mftktp37">
          <h3 className="font-bold text-text-dark text-xl mb-2" data-id="element-1619" data-mp="3q3hkjumb3ktr">
            Still have questions?
          </h3>
          <p className="text-text-muted text-sm mb-5" data-id="element-1620" data-mp="3l4ocwitpao1i">
            Our team is available 24/7 to help you get started
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center" data-id="element-1621" data-mp="3ooqp49wxgvu">
            <a href="tel:+18005551234" className="bg-medical-blue text-white font-bold px-6 py-3 rounded-xl hover:bg-medical-blue-dark transition-colors text-sm" data-id="element-1622" data-mp="3v22nw2wuukmf">
              📞 Call 1-800-555-1234
            </a>
            <a href="#" className="bg-white text-medical-blue font-bold px-6 py-3 rounded-xl border-2 border-medical-blue hover:bg-soft-teal transition-colors text-sm" data-id="element-1623" data-mp="32bswwrkfjkj5">
              💬 Live Chat
            </a>
          </div>
        </div>
      </div>
    </section>;
}
function FAQAccordion({
  items
}: {
  items: FAQItem[];
}) {
  return <>
      {items.map((item, index) => <FAQItem key={index} item={item} data-id="element-1624" data-mp="20mm0s1hnd933" data-mpi={index} />)}
    </>;
}
function FAQItem({
  item
}: {
  item: FAQItem;
}) {
  return <details className="group bg-white border border-gray-200 rounded-xl overflow-hidden" data-id="element-1625" data-mp="25lp6zp9d5lcn">
      <summary className="flex items-center justify-between px-6 py-4 cursor-pointer list-none hover:bg-soft-teal transition-colors" data-id="element-1626" data-mp="1rmh3ik663r2n">
        <span className="font-semibold text-text-dark text-sm pr-4" data-id="element-1627" data-mp="1wj7j76e28knj">
          {item.question}
        </span>
        <span className="text-medical-blue text-xl font-light flex-shrink-0 group-open:rotate-45 transition-transform duration-200" data-id="element-1628" data-mp="g57lm22ot73g">
          +
        </span>
      </summary>
      <div className="px-6 pb-5 pt-1" data-id="element-1629" data-mp="2mtgc3lbal0yh">
        <p className="text-text-muted text-sm leading-relaxed" data-id="element-1630" data-mp="2mwlz8v0d1srk">{item.answer}</p>
      </div>
    </details>;
}